import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './components/theme/theme-provider';
import { BrandingProvider } from './components/theme/branding-provider';
import { AuthProvider } from './components/auth/auth-provider';
import { StandortProvider } from './components/layouts/StandortContext';
import { PermissionProvider } from './components/rbac/PermissionProvider';
import AppRoutes from './components/AppRoutes';
import { AppToaster } from './components/ui/sonner';
// Create a client for React Query
const queryClient = new QueryClient();
export function App() {
  return <ThemeProvider defaultTheme="system" storageKey="sidigo-theme">
      <BrandingProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <PermissionProvider>
              <BrowserRouter>
                <StandortProvider>
                  <div className="min-h-screen bg-background font-sans antialiased">
                    <AppRoutes />
                    <AppToaster />
                  </div>
                </StandortProvider>
              </BrowserRouter>
            </PermissionProvider>
          </AuthProvider>
        </QueryClientProvider>
      </BrandingProvider>
    </ThemeProvider>;
}